import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MaterialModule } from '../modules/material/material.module';
import { I18nModule } from '../modules/i18n/i18n.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxEchartsModule } from 'ngx-echarts';
import { TooltipModule } from './components/tooltip/tooltip.module';
import { PaginationModule } from './components/pagination/pagination.module';
import { PipesModule } from './pipes/pipes.module';
import { DialogComponent } from './components/dialog/dialog.component';
import { TermsOfUseComponent } from './components/dialog/terms-of-use/terms-of-use.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { PageSubheaderComponent } from './components/page-subheader/page-subheader.component';
import { PillTabsComponent } from './components/pill-tabs/pill-tabs.component';
import { PortalDetailDrawerComponent } from './components/portal-detail-drawer/portal-detail-drawer.component';
import { PortalDetailSectionComponent } from './components/portal-detail-section/portal-detail-section.component';
import { PortalListSurfaceComponent } from './components/portal-list-surface/portal-list-surface.component';
import { PortalStatusPillComponent } from './components/portal-status-pill/portal-status-pill.component';
import { OpsPresenceComponent } from './components/ops-presence/ops-presence.component';
import { QuickTaskComponent } from './components/quick-task/quick-task.component';
import { PortalTableCellDirective } from './components/portal-table/portal-table-cell.directive';
import { PortalTableComponent } from './components/portal-table/portal-table.component';
import { PortalTableFooterComponent } from './components/portal-table-footer/portal-table-footer.component';
import { PortalToolbarComponent } from './components/portal-toolbar/portal-toolbar.component';
import { CommingSoonComponent } from './components/comming-soon/comming-soon.component';
import { InvalidPageComponent } from './components/invalid-page/invalid-page.component';
import { TableComponent } from './components/table/table.component';
import { ServiceNotAvailableComponent } from './components/service-not-found/service-not-available.component';
import {
  SucessSnackBarComponent,
  SucessBigSnackBarComponent,
  ErrorSnackBarComponent,
  InfoSnackBarComponent,
} from './components/snack-bar/snack-bar.component';
import { MetricDialogComponent } from './components/dialog/metric-dialog/metric-dialog.component';
import { SpinerLoaderComponent } from './components/spiner-loader/spiner-loader.component';
import { PdfApryseComponent } from './components/pdf-apryse-viewer/pdf-apryse.component';
import { FilterMenuComponent } from './components/FilterMenu/filter-menu.component';
import { DndDirective } from './directives/dnd.directive';
import { MatSelectPositionDirective } from './directives/select-pos.directive';
import { PCMenuPositionDirective } from './directives/portfolio-company-position.directive';
import { PersonNamePositionDirective } from './directives/person-name-position.directive';
import { InvoicePositionDirective } from './directives/invoice-position.directive';
import { MatMenuPositionDirective } from './directives/mat-menu-position.directive';
import { PreventInputFieldScrollDirective } from './directives/prevent-input-field-scroll.directive';
import { AvatarImageDirective } from './directives/avatar-image.directive';
import { DeadlineCountdownComponent } from '../shared/components/deadline-countdown/deadline-countdown.component';

const UI_DECLARATIONS = [
  DialogComponent,
  TermsOfUseComponent,
  SearchBarComponent,
  EmptyStateComponent,
  PageSubheaderComponent,
  PillTabsComponent,
  PortalDetailDrawerComponent,
  PortalDetailSectionComponent,
  PortalListSurfaceComponent,
  PortalStatusPillComponent,
  OpsPresenceComponent,
  QuickTaskComponent,
  PortalTableCellDirective,
  PortalTableComponent,
  PortalTableFooterComponent,
  PortalToolbarComponent,
  CommingSoonComponent,
  InvalidPageComponent,
  TableComponent,
  ServiceNotAvailableComponent,
  SucessSnackBarComponent,
  SucessBigSnackBarComponent,
  ErrorSnackBarComponent,
  InfoSnackBarComponent,
  MetricDialogComponent,
  SpinerLoaderComponent,
  PdfApryseComponent,
  FilterMenuComponent,
  DndDirective,
  MatSelectPositionDirective,
  PCMenuPositionDirective,
  PersonNamePositionDirective,
  InvoicePositionDirective,
  MatMenuPositionDirective,
  PreventInputFieldScrollDirective,
  AvatarImageDirective,
  DeadlineCountdownComponent,
];

@NgModule({
  declarations: UI_DECLARATIONS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    I18nModule,
    NgxSkeletonLoaderModule,
    NgxEchartsModule,
    TooltipModule,
    PaginationModule,
    MatProgressSpinnerModule,
    PipesModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    DragDropModule,
  ],
  exports: [
    ...UI_DECLARATIONS,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    I18nModule,
    NgxSkeletonLoaderModule,
    NgxEchartsModule,
    TooltipModule,
    PaginationModule,
    MatProgressSpinnerModule,
    PipesModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    DragDropModule,
  ],
  providers: [DatePipe],
})
export class SharedUiModule {}
